import React, { useContext, useEffect, useMemo, useRef, useState } from "react"
import './Calendar.css';
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackward, faForward, faForwardStep } from "@fortawesome/free-solid-svg-icons";
import { STATES } from "../../utils/states";
import authContext from "../../context/authentication/authContex";
import Swal from "sweetalert2";
import ContextualMenu from "../TreeActivo/ContextuaLMenu";
import ContextualMenuCalendar from "./ContextualMenuCalendar";
import Modal from '../modalForm/ModalForm';

export const Calendar = ({data = [], getAndMergeTDocsByFecAlt, setShowCalendar, handlerDetails, monthsAlreadyLoaded, editar}) => {

    const [month,setMonth] = useState(moment().startOf('month'));
    const [daysToRender, setDaysToRender] = useState([]);
    const [docDragged, setDocDragged] = useState(null);
    const [showContextualMenu,setShowContextualMenu] = useState(null);
    const [showModalDeliveryDate, setShowModalDeliveryDate] = useState(false);

    const days = () => {
        const start = month.clone().startOf('week');
        const days = [];
        let current = start.clone();
        for(let i = 0; i < 42; i++){
            days.push(current.clone());
            current.add(1, 'day');
        }
        return days;
    }

    const getDetails = (d) => {
        setShowCalendar(false);
        handlerDetails(d);
    }
    
    const handleSetBack30Days = async () => {
        let newDate = month.clone();
        if(!monthsAlreadyLoaded.current?.some(m => m == month.clone().subtract(1, 'month').format('YYYY-MM'))){
            monthsAlreadyLoaded.current = [...monthsAlreadyLoaded.current, month.clone().subtract(1, 'month').format('YYYY-MM')];
            // await getAndMergeTDocsByFecAlt(usuario._id, {fecAlt:{desde: new Date(newDate.clone().subtract(1,'month').startOf('month').startOf('week')), hasta: new Date(newDate.clone().subtract(1,'month').endOf('month').endOf('week'))}})
        }
        setMonth(month.clone().subtract(1, 'month'));
    }
    const handleAdvance30Days = () => {
        setMonth(month.clone().add(1, 'month'));
    }

    const onDragStart = (doc, day) => {
        setDocDragged(doc);
    }

    const updateDate = (formattedDate) => {
        let deliveryDateToUpdate = new Date(moment(formattedDate));
        let tDocId = docDragged._id;
        let updates = {_id: tDocId, deliveryDateToUpdate, fecMod: docDragged.fecMod};
        editar(updates, [], undefined, undefined, 'calendar');
    }

    const onDocDropped = (day) => {
        if(day.formatedDate != moment(docDragged.deliveryDate).startOf('day').format('YYYY-MM-DD')){
            Swal.fire({
                title: "Ops!",
                text: "Esta seguro de querer actualizar la fecha de entrega estimada de la ODT?",
                confirmButtonText:'Sí, estoy seguro',
                showCancelButton: true,
                cancelButtonText:'Cancelar',
                icon:'warning'
            })
            .then(res => {
                if(res.isConfirmed){
                    updateDate(day.formatedDate);
                }else{
                    setDaysToRender(prevDays => {
                        let newDays = [...prevDays];
                        let index = newDays.findIndex(d => d.formatedDate == day.formatedDate);
                        newDays[index].isHovered = false;
                        return newDays;
                    })
                }
            })
        }else{
            setDaysToRender(prevDays => {
                let newDays = [...prevDays];
                let index = newDays.findIndex(d => d.formatedDate == day.formatedDate);
                newDays[index].isHovered = false;
                return newDays;
            })
        }
    }

    //Cada vez que se entra a un dia con un documento arrastrado o se sale, se setea el estado isHovered de ese dia.
    const handleDragEnterLeaveOTDiv = (e, flag, dayIndex) => {
        if(!flag && !e.currentTarget.contains(e.relatedTarget)){
            setDaysToRender(prevDays => {
                let newDays = [...prevDays];
                newDays[dayIndex].isHovered = flag;
                return newDays;
            })  
        }else if(flag){
            setDaysToRender(prevDays => {
                let newDays = [...prevDays];
                newDays[dayIndex].isHovered = flag;
                return newDays;
            })
        }        
    }

    useEffect(()=>{
        let daysToModelate = days();
        let docsFiltered = [...data];
        let daysModelated = daysToModelate.map(d => {
            const docs = [];

            docsFiltered = docsFiltered.filter(doc => {
                const isSameDay = moment(doc.deliveryDate).isSame(d, 'day');
                if(isSameDay){
                    docs.push(doc);
                    return false; //Gracias al filter sera eliminado de los docsFiltered, reduciendo la lista a recorrer en el siguiente dia.
                }else return true;
            })

            return {
                formatedDate: `${d.format('YYYY-MM-DD')}`,
                docs,
                docsFiltered: docs
            };
        })
        setDaysToRender(daysModelated);
    },[data, month])

    const handleContextMenu = (e, doc) => {
        e.stopPropagation();
        e.preventDefault();
        setShowContextualMenu({x: e.clientX, y: e.clientY, nodeId: doc});
    }

    const handleChangeDeliveryDate = (doc) => {
        setDocDragged(doc);
        setShowModalDeliveryDate(true);
    }

    const minimizarModalDDate = () => {
        setShowModalDeliveryDate(false);
    }

    return <div className="calendarContainer">
        <button onClick={()=>setShowCalendar(false)} className="minimizarBtn closeCalendarBtn">X</button>
        <div className="calendarTableContainer">
            <div className="monthArrows">
                <button className="moveBetweenDaysBtns" onClick={handleSetBack30Days}> <FontAwesomeIcon icon={faBackward}/> </button>
                <h4 style={{textAlign:'center', color:'white', width: 150}}>{`${month.format('MMMM').charAt(0).toUpperCase()}${month.format('MMMM').slice(1)}`}</h4>
                <button className="moveBetweenDaysBtns" onClick={handleAdvance30Days}> <FontAwesomeIcon icon={faForward}/> </button>
            </div>
            <div className="daysColumns">
                <h5>Lunes</h5>
                <h5>Martes</h5>
                <h5>Miercoles</h5>
                <h5>Jueves</h5>
                <h5>Viernes</h5>
                <h5>Sabado</h5>
                <h5>Domingo</h5>
            </div>
            <div className="calendarTable"> 
                {
                    daysToRender?.map((d, i) => <div className={`${d.isHovered ? 'hovered' : ''} day`} onDragEnter={(e)=>handleDragEnterLeaveOTDiv(e, true, i)} onDragOver={e => e.preventDefault()} onDragLeave={(e)=> handleDragEnterLeaveOTDiv(e, false, i)}
                         onDrop={()=>onDocDropped(d)}>
                        <span className="formattedDate">{d?.formatedDate}</span>
                        <div className="containerDocsDay">
                            {
                                d.docsFiltered?.map(doc => <div title="Ver Detalles" className={`docWithinCalendar ${doc.state == 'PENDIENTE' ? 'grayBg' : doc.state == 'FINALIZADA' ? 'greenBg' : 'orangeBg'}`} onClick={()=>getDetails(doc)} draggable onDrag={()=>onDragStart(doc, d)} onContextMenu={(e) => handleContextMenu(e, doc)}>
                                    <div style={{backgroundColor: doc.state == 'PENDIENTE' ? 'gray' : doc.state == 'FINALIZADA' ? 'green' : 'orange', width: 7.5, height: 7.5, borderRadius:'50%'}}/><span>{`${doc.tDocCodFor}-${doc.tDocNroFor} , ${doc.codActivo}`} </span>
                                </div>)
                            }
                        </div>
                    </div>)
                }            
            </div>
        </div>
        {
            (showContextualMenu?.y && showContextualMenu?.x) && <ContextualMenuCalendar showContextualMenu={showContextualMenu} setShowContextualMenu={setShowContextualMenu} handleChangeDeliveryDate={handleChangeDeliveryDate}/>
        }
        {
            showModalDeliveryDate && <Modal doc={docDragged} formToShow={"deliveryDate"} minimizar={minimizarModalDDate} updateDate={updateDate}/>
        }
    </div>
}

